import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/Pages.css';

import heroImage from '../assets/images/hero2.jpg';

const Highways = ({ onNavigate }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="service-page">
      <Header onNavigate={onNavigate} />

      {/* PAGE TITLE */}
      <section className="page-title" style={{ backgroundImage: `url(${heroImage})` }}>
        <div className="overlay">
          <div className="container">
            <h1>Highways</h1>
            <p>National Highway & Road Infrastructure Development</p>
          </div>
        </div>
      </section>

      {/* SERVICE DESCRIPTION */}
      <section className="service-description">
        <div className="container">
          <h2>Our Expertise in Highway Construction</h2>
          
          <p>
            Max Infra is a leading highway construction company with extensive experience 
            in developing national highways, state highways, and major road corridors across India. 
            Our expertise includes multi-lane highway development, elevated highways, and 
            complex infrastructure in challenging terrains.
          </p>

          <p>
            We specialize in large-scale highway projects that connect major cities and 
            facilitate national economic development. Our commitment to quality, safety, and 
            timely delivery has made us a trusted partner for highway development projects 
            with NHAI and other government agencies.
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Highways;